import { createWebHistory, createRouter } from "vue-router";
import routes from "./routes";
// import { errorMsg } from "@/helpers/alerts.js";
import { useAuthStore } from "@/store/auth";

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, left: 0 };
  },
});

router.beforeEach((routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  const authStore = useAuthStore();

  if (!authStore.isLoggedIn) {
    return next({
      name: "login",
      query: { redirectFrom: routeTo.fullPath },
    });
  }

  authStore
    .getUser()
    .then((data) => {
      const abilities = data?.info?.abilities || [];

      if (routeTo.meta.acc) {
        const acc = routeTo.meta.acc;

        if (typeof acc === "string") {
          if (!abilities.includes(acc)) {
            return next({ name: "login" });
          }
          return next();
        }

        // if (Array.isArray(acc)) {
        //   const hasAccess = abilities.some((a) => acc.includes(a));

        //   if (!hasAccess) {
        //     errorMsg("Access denied");
        //     return next({ name: "login" });
        //   }

        //   return next();
        // }
        return next();
      }
      next();
    })
    .catch(() => {
      next({ name: "login" });
    });
});
router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      if (route.meta?.beforeResolve) {
        await new Promise((resolve, reject) => {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        });
      }
    }
  } catch {
    return;
  }

  if (routeTo.meta?.title) {
    document.title = routeTo.meta.title;
  }

  next();
});

export default router;
